export default "__VITE_ASSET__BLMF82YR__"